import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const InfoTagSvg = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='21' height='21' viewBox='0 0 21 21' fill='none'>
    <path
      d='M10.4704 2.30794C5.86801 2.30794 2.13705 6.0389 2.13705 10.6413C2.13705 15.2436 5.868 18.9746 10.4704 18.9746C15.0728 18.9746 18.8037 15.2436 18.8037 10.6413C18.8037 6.0389 15.0728 2.30794 10.4704 2.30794Z'
      stroke='#5E678C'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10.4707 13.9751L10.4707 10.6418'
      stroke='#5E678C'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10.4707 7.30811L10.4624 7.30811'
      stroke='#5E678C'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const InfoTagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={InfoTagSvg} color='#3F3D56' {...props} />
);
